import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { ChevronLeft } from 'lucide-react';

interface HeadingProps {
  title: string;
  back?: boolean;
  className?: string;
  onBack?: () => void;
}

export function Heading({ title, back, className, onBack }: HeadingProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center', className)}>
      {back && (
        <Button
          onClick={onBack}
          variant="outline"
          className="flex-center-center size-10 p-0 mr-6"
        >
          <ChevronLeft />
        </Button>
      )}

      <h1 className={cn('text-black text-2xl font-semibold')}>{t(title)}</h1>
    </div>
  );
}
